import Page from "./page";
import { useTranslation } from "react-i18next";
import qrcode from '../../assets/software/qrcodeOrange.png';
import Pic1 from '../../assets/software/customer/1.png';
import Pic2 from '../../assets/software/customer/2.png';
import logo1 from '../../assets/software/customer/logo1.png';
import logo2 from '../../assets/software/customer/logo2.png';
import main from '../../assets/software/customer/main.png';
import u1 from "../../assets/software/u1.png";
import u2 from "../../assets/software/u2.png";
import u3 from "../../assets/software/customer/u3.png";
import u4 from "../../assets/software/customer/u4.png";
function Selfhelp() {
  let { t } = useTranslation();

  const datas = [
    {
      pic: Pic1,
      logo: logo1,
      title: t("customerType.reportTitle"),
      infos: [
        t("customerType.reportInfo1")
      ],
      bgcolor: "rgb(255,248,240)",
    },
    {
      pic: Pic2,
      logo: logo2,
      title: t("customerType.goodsTitle"),
      infos: [
        t("customerType.goodsInfo1")
      ],
    }
  ]
  return (
    <Page
      {...{
        title: t("customerType.title"),
        content: t("customerType.info"),
        pic: main,
        bgColor: "rgba(255, 142, 43, 1)",
        linearGradient: 'linear-gradient(161.37deg, rgba(255, 106, 0, 1) 0%, rgba(255, 153, 64, 1) 100%)',
        downInfo: {
          bgColor: "#ff8122",
          qrBgColor: '#ffebd1',
          qrcode: qrcode,
          urlName: 'toposify_cds',
          url1: "https://play.google.com/store/apps/details?id=com.htsd.toposify_cds.toposify_cds",
          url2: "https://itunes.apple.com/app/6742737842",
          u1: u1,
          u2: u2,
          u3: u3,
          u4: u4,
          showWin: false
        },
        bodyDatas: datas,
        textColor: '#fff'
      }}
    />
  );
}

export default Selfhelp;

